import { render, staticRenderFns } from "./TableComplaint.vue?vue&type=template&id=6da9d36d&scoped=true"
import script from "./TableComplaint.vue?vue&type=script&lang=js"
export * from "./TableComplaint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9d36d",
  null
  
)

export default component.exports